import React from 'react'
import { Container, Icon } from 'gu-ui-kit'
import styles from 'modules/Finance/PaymentProfiles/List/subcomponents/StatusIcon/status-icon.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const StatusIcon = ({ status, breakpoints }) => {
  return (
    <Container
      display={'flex'}
      className={clsx(styles['container'], {
        [styles['container_' + status]]: status,
        [styles['container_small']]: breakpoints.sm,
      })}
    >
      <Icon
        name={'user'}
        size={breakpoints.sm ? 's' : 'm'}
        className={clsx(styles['icon'], {
          [styles['icon_' + status]]: status,
        })}
      />
    </Container>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['new', 'pending', 'approved', 'declined']),
  breakpoints: PropTypes.object,
}

export default StatusIcon
